import { Inject, Injectable, Sanitizer } from '@angular/core';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { switchMapTo } from 'rxjs/operators/switchMapTo';
import { map } from 'rxjs/operators/map';
import { refCount } from 'rxjs/operators/refCount';
import { publishReplay } from 'rxjs/operators/publishReplay';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ThemingService {

  public currentThemeUrl$: Observable<string>;

  private themeLinkElement: any;
  private bodyElement: any;

  private fetchTrigger: Subject<any> = new Subject();

  constructor(private http: HttpInterceptorService, private sanitizer: Sanitizer, @Inject(DOCUMENT) private  _document: Document) {

  }

  public fetchDefaultTheme() {
    this.fetchTheme('default');
  }

  public fetchTheme(themeColor) {
    this.currentThemeUrl$ = this.fetchTrigger.pipe(switchMapTo(
      this.http.get<{ theme: string }>('/theme/getTheme/' + themeColor).pipe(
        map(response => btoa(response.body.theme)),
        map(base64Style => `data:text/css;base64,${base64Style}`),
        publishReplay(1),
        refCount()
      )
    ));
    this.bodyElement = this._document.body;
    this.currentThemeUrl$
      .subscribe(themeUrl => {
        if (this.themeLinkElement) {
          this.bodyElement.removeChild(this.themeLinkElement);
        }
        this.themeLinkElement = this._document.createElement('link');
        this.themeLinkElement.setAttribute('rel', 'stylesheet');
        this.themeLinkElement.setAttribute('href', themeUrl);
        this.bodyElement.appendChild(this.themeLinkElement);
      });
    this.fetchTrigger.next();
  }

}
